const _ = require('lodash');

exports.testFunction = function() {
    console.log("Test Function called");
}

exports.testFuncWithLodash = function() {
    let x = ['a','b','c'];
    console.log( _.first(x) );
}




// WEBPACK FOOTER //
// ./src/lib/testlib.js